export default __webpack_public_path__ + "static/media/blog-33-image-1.11219cc2.jpg";